import { post } from '@/common/request';

const supplierMap = new Map([
  // 企业信息
  ['list', '/tenant/supplier/page'],
  ['add', '/tenant/supplier/create'],
  ['edit', '/tenant/supplier/update'],
  ['delete', '/tenant/supplier/delete'],
  ['detail', '/tenant/supplier/detail'],
  ['selectList', '/tenant/supplier/list'],
  ['supplierList', '/tenant/supplier/list'],

  // 联系人信息
  ['contactList', '/tenant/supplierContact/page'],
  ['contactAdd', '/tenant/supplierContact/create'],
  ['contactEdit', '/tenant/supplierContact/update'],
  ['contactDelete', '/tenant/supplierContact/delete'],

  // 供给状态修改
  ['editStatus', '/tenant/spotSupply/update/status'],
  ['pointList', '/tenant/spotSupply/page'],
  ['pointEdit', '/tenant/spotSupply/update'],
  ['pointAdd', '/tenant/spotSupply/create'],

  // 收款账户
  ['collectionList', '/tenant/supplierAccount/page'],
  ['collectionAdd', '/tenant/supplierAccount/create'],
  ['collectionEdit', '/tenant/supplierAccount/update'],
  ['collectionDetail', '/tenant/supplierAccount/detail'],
  ['collectionDelete', '/tenant/supplierAccount/delete']
]);

export function addSupplier(params?: any) {
  return post('/tenant/supplier/create', { ...params }, { needHint: true, proxyApi: '/resserv' });
}



export default supplierMap;
